export default class {
  constructor (model) {
    this.id = model.id
    this.name = model.name
    this.isFree = model.isFree
    this.onSite = model.onSite
    this.distance = model.distance
    this.highSeasonOnly = model.highSeasonOnly
  }

  // retourne si un item est valide
  get isValid () {
    return this.isFree !== null || this.onSite !== null
  }
}
